import React, { useEffect, useRef } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';
import {
  fetchRcptData,
  selectReceiptData,
  selectReceiptLoading
} from '../../Store/PHPSlice/ReceiptApi/receiptApi';
import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';

const RcptPrint = () => {
  const { Id, type } = useParams();
  const dispatch = useDispatch();
  const componentRef = useRef();

  const rcptData = useSelector(selectReceiptData);
  const loading = useSelector(selectReceiptLoading);

  useEffect(() => {
    dispatch(fetchRcptData({ id: Id, type }));
  }, [Id, type, dispatch]);

  if (loading) return <p>Loading...</p>;
  if (!rcptData) return <p>No receipt data found</p>;
 function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    }
  return (
    <Grid item xs={12}>
      <Paper>
        <div ref={componentRef} style={{ padding: '20px' }}>
          {rcptData.firmId && <FirmHeaderImg firmId={rcptData.firmId} />}
           <table width="100%" cellPadding="6" cellSpacing="0" style={{ borderCollapse: "collapse" }}>
  <tbody>

    {/* RECEIPT TITLE */}
    <tr>
      <td colSpan={3} style={{ border: "1px solid #000" }}>
        <h2 style={{ textAlign: "center", color: "red", margin: 0 }}>
          {rcptData.rcptType}
        </h2>
      </td>
    </tr>

    {/* RECEIPT NO & DATE */}
    <tr>
      <td align="left" style={{ borderRight: "1px solid #fff" }}>
        <b style={{ color: "red" }}>Receipt No :</b> {rcptData.rcptNo}
      </td>

      <td  style={{ borderRight: "1px solid #fff" }}/>

      <td align="right" style={{ borderLeft: "1px solid #fff" }}>
        <b style={{ color: "red" }}>Date :</b> {rcptData.dt}
      </td>
    </tr>

    {/* PARTY TEXT */}
    <tr>
      <td colSpan={3} style={{ border: "1px solid #000" }}>
        {rcptData.rcptType === "Advance Receipt" && (
          <>
            Advance given for{" "}
            <span style={{ fontWeight: "bold", fontStyle: "italic", textDecoration: "underline" }}>
              Mr/Mrs {rcptData.partyNm}
            </span>
          </>
        )}

        {rcptData.rcptType === "Return Goods Receipt" && (
          <>
            Return goods amount given to{" "}
            <span style={{ fontWeight: "bold", fontStyle: "italic", textDecoration: "underline" }}>
              Mr/Mrs {rcptData.partyNm}
            </span>
          </>
        )}

        {rcptData.rcptType !== "Advance Receipt" &&
          rcptData.rcptType !== "Return Goods Receipt" && (
            <>
              Received with thanks from{" "}
              <span style={{ fontWeight: "bold", fontStyle: "italic", textDecoration: "underline" }}>
                {rcptData.partyNm}
              </span>
            </>
          )}
      </td>
    </tr>

    {/* AMOUNT IN WORDS */}
    <tr>
      <td colSpan={3} style={{ border: "1px solid #000" }}>
        <b style={{ fontStyle: "italic", textDecoration: "underline" }}>
          {numberToWords(parseFloat(rcptData.paidAmt))} RUPEES ONLY
        </b>
      </td>
    </tr>

    {/* PAYMENT MODE + AMOUNT BOX */}
    <tr>
      {/* PAYMENT DETAILS */}
      <td colSpan={2} align="left" valign="top" style={{ borderRight: "1px solid #fff" }}>
        <b>{rcptData.paymode?.toUpperCase()}</b>

        {rcptData.paymode === "bank" && (
          <div style={{ marginTop: 6 }}>
            Bank : {rcptData.bank_name} <br />
            Cheque No : {rcptData.cheque_no} <br />
            Cheque Date : {rcptData.cheque_dt}
          </div>
        )}

        {rcptData.paymode === "online" && (
          <div style={{ marginTop: 6 }}>
            Mode : {rcptData.online_payment_method} <br />
            Transaction ID : {rcptData.transaction_id}
          </div>
        )}

        {rcptData.paymode === "cash" && <div>Cash Payment</div>}
      </td>

      {/* PAID AMOUNT BOX */}
      <td align="right" valign="middle" style={{ border: "1px solid #000" }}>
        <div
          style={{
            border: "3px solid #000",
            padding: "12px 20px",
            fontSize: "18px",
            fontWeight: "bold",
            display: "inline-block",
            minWidth: "160px",
            textAlign: "center"
          }}
        >
          ₹ {rcptData.paidAmt}
        </div>
      </td>
    </tr>

    {/* FOOTER : FIRM NAME */}
    <tr>
      <td colSpan={3} align="right" style={{ border: "1px solid #000", paddingTop: "40px" }}>
        <b>For {rcptData.fmnm}</b>
        <br />
        <span style={{ fontSize: "12px" }}>Authorised Signatory</span>
      </td>
    </tr>

  </tbody>
</table>

       
        </div>

        <div style={{ margin: '20px' }}>
          <ReactToPrint
            trigger={() => <Button variant="contained">PRINT</Button>}
            content={() => componentRef.current}
          />
        </div>
      </Paper>
    </Grid>
  );
};

export default RcptPrint;
